import { Container, Separator, Text } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import BoxNotice from '../components/common/BoxNotice';
import ErrorBoundary from '../components/common/ErrorBoundary';
import MandatesProvider from '../components/common/MandatesProvider';
import LimitedMandateNotice from '../components/invoice/notices/LimitedMandateNotice';
import PaymentHistoryDesktop from '../components/invoice/transactions/PaymentHistoryDesktop';
import PaymentHistoryMobile from '../components/invoice/transactions/PaymentHistoryMobile';
import AnalyticsService from '../services/AnalyticsService';
import ZebraPadding from '../components/common/ZebraPadding';
import { ILayoutStore } from '../stores/LayoutStore';
import MandatesStore from '../stores/MandatesStore';
import { IPaymentHistoryStore } from '../stores/PaymentHistoryStore';
import { ITransactionStore } from '../stores/TransactionStore';
import { ITranslateStore } from '../stores/TranslateStore';

interface IPaymentHistoryProps {
  transactionStore?: ITransactionStore;
  translateStore?: ITranslateStore;
  mandatesStore?: MandatesStore;
  analyticsService?: AnalyticsService;
  paymentHistoryStore?: IPaymentHistoryStore;
  layoutStore?: ILayoutStore;
}

@inject('transactionStore', 'translateStore', 'mandatesStore', 'analyticsService', 'paymentHistoryStore', 'layoutStore')
@observer
export default class PaymentHistory extends React.Component<IPaymentHistoryProps> {
  public async componentDidMount(): Promise<void> {
    this.props.analyticsService.previousInvoicesViewPage();
    await this.props.paymentHistoryStore.loadTransactions();
  }

  public render(): JSX.Element {
    return (
      <Text className="nls_protected">
        <MandatesProvider render={() => this.content()} />
      </Text>
    );
  }

  private content(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const mandate = this.props.mandatesStore.mandate;

    if (mandate.payload.billingMandateLevel !== 'FULL') {
      return (
        <ZebraPadding>
          <Container>
            <h1>{translate('payment-history.title')}</h1>
            <Separator spacing="xsmall" color="invisible" />
            <BoxNotice>{translate('shared.notices.no-mandate-notice')}</BoxNotice>
          </Container>
        </ZebraPadding>
      );
    }

    return (
      <ZebraPadding>
        <Container>
          <LimitedMandateNotice />
          <ErrorBoundary errorTranslationKey="payment-history.errors.loading-transactions-failed">
            {this.props.layoutStore.isMobile ? <PaymentHistoryMobile /> : <PaymentHistoryDesktop />}
          </ErrorBoundary>
          <Separator spacing="small" color="invisible" />
        </Container>
      </ZebraPadding>
    );
  }
}
